// for print
import { MessageBox, Message, Notification } from "element-ui";
import {
  printOrder,
  printUnit,
  getPrintCount,
  getOrderPrintStatus,
  getUnitPrintStatus,
  getPrintOrderFile,
  getPrintingId,
  cancelPrintOrder,
  cancelPrintUnit,
  changeOrderPrintStatus,
  changeUnitPrintStatus
} from "@/services/fulfillment-api";

const PRINTING_STATUS = 2;
const FAILURE_STATUS = 3;
const CANCELED_STATUS = 0;
const SUCCESS_STATUS = 1;

export default {
  data() {
    return {
      printCountDialogVisible: false,
      printingDialogVisible: false,
      // 打印中的元素
      printingItems: {
        orders: [],
        units: []
      },
      // 轮询队列
      pollingQueue: {
        orders: [],
        units: []
      },
      is_printing_order: false,
      is_printing_unit: false,
      pInstance: { closed: true },
      sInstance: { closed: true },
      printTableData: [],
      // 打印成功的列表
      successList: []
    };
  },
  computed: {
    // 正在打印中, order 或 unit正在打印
    isPrinting() {
      return this.is_printing_order || this.is_printing_unit;
    }
  },
  methods: {
    // 打开打印统计弹窗
    openPrintCountDialog() {
      this.printCountDialogVisible = true;
    },
    // 打开打印统计弹窗
    openPrintingDialog() {
      this.printingDialogVisible = true;
      // 此时需要关闭 printing notify
      this.pInstance.closed === false && this.pInstance.close();
    },
    // 单独打印 / reprint Order
    async handlePrintOrder(command, order, isReprint) {
      let message = this.$t("ffm_confirm_to_print");
      if (isReprint) {
        message = this.$t("ffm_confirm_recycled");
      }
      await MessageBox.confirm(message, "Alert", {
        type: "info"
      });
      // 单独打印 booking
      let params = [order.order_base_info_id || order.order_base_id];
      if (command === "cloud") {
        this.printOrderOnCloud(params);
      } else {
        await MessageBox.confirm("Please allow pop up windows", "Alert", {
          type: "info"
        });
        try {
          // done jacob:修改文件访问方式
          let res = await getPrintOrderFile(params);
          console.log("1:", res);
          let file = new Blob([res.data], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          let win;
          console.log("env:", process.env.NODE_ENV);
          if (!process.env.NODE_ENV.startsWith("dev")) {
            win = window.open(fileURL);
          } else {
            win = window.open(fileURL);
          }
          // let win = window.open(res.result.file_path);
          win.onload = () => {
            this.openConfirmWindow(params, "order", [
              order.order_base_info.ticket_id
            ]);
          };
        } catch (err) {
          console.log(err);
          Message(this.$t("ffm_print_status_failed"));
        }
      }
    },
    // 逆向流单独打印unit
    async handlePrintUnit(command, unit, isReprint, indialog) {
      let message = this.$t("ffm_confirm_to_print");
      if (isReprint) {
        message = this.$t("ffm_confirm_recycled");
      }
      // CEG针对单张unit reprint, 但是并没有单张unit文件, 提示打印整张booking, 前端加提示
      if (!unit.file_path && !indialog) {
        message =
          "Please select the specific page to reprint, otherwise you will reprint all the tickets in this order";
      }
      await MessageBox.confirm(message, "Alert", {
        type: "info"
      });
      // 单独打印 booking
      let params = {
        order_base_id: unit.order_base_id, // in query, order_base_id,
        unit_file_id: unit.id || unit.unit_file_id
      };
      if (command === "cloud") {
        this.printUnitOnCloud(params);
      } else {
        await MessageBox.confirm("Please allow pop up windows", "Alert", {
          type: "info"
        });
        try {
          // unit.file_path为空, 标识只能打印整张booking
          let path = unit.file_path;
          if (!path) {
            let res = await getPrintOrderFile([unit.order_base_id]);
            // path = res.result.file_path;
            console.log("2:", res);
            let file = new Blob([res.data], { type: "application/pdf" });
            let fileURL = URL.createObjectURL(file);
            path = fileURL;
          }
          let win;
          if (!process.env.NODE_ENV.startsWith("dev")) {
            win = window.open(path);
          } else {
            win = window.open(path);
          }
          win.onload = () => {
            this.openConfirmWindow(
              [params.unit_file_id],
              "unit",
              [params.unit_file_id],
              unit.order_base_id
            );
          };
        } catch (err) {
          console.log(err);
          Message(this.$t("ffm_print_status_failed"));
        }
      }
    },
    // 批量打印, 后端返回分类好的数据
    async handleBatchPrint() {
      // 获取统计信息 - 只统计正向流
      let arr = this.selectedItems.filter(v => !v.hasReverse) || [];
      if (!arr.length) {
        Message(this.$t("ffm_select_print_orders_are_abnormal"));
        return;
      }
      // 统计每一类数量
      let res = await getPrintCount(arr.map(v => v.order_base_info_id));
      this.printTableData = res.result;
      this.openPrintCountDialog();
    },
    // 统计弹窗的每一行的打印
    async handlePrintGroup(command, group) {
      await MessageBox.confirm(this.$t("ffm_confirm_to_multiprint"), "Alert", {
        type: "info"
      });
      // 单独打印 booking
      if (command === "cloud") {
        this.printOrderOnCloud(group.order_base_id_list);
        this.printCountDialogVisible = false;
      } else {
        await MessageBox.confirm("Please allow pop up windows", "Alert", {
          type: "info"
        });
        try {
          let res = await getPrintOrderFile(group.order_base_id_list);
          console.log("3:", res);
          let file = new Blob([res.data], { type: "application/pdf" });
          let fileURL = URL.createObjectURL(file);
          let win;
          if (!process.env.NODE_ENV.startsWith("dev")) {
            win = window.open(fileURL);
          } else {
            win = window.open(fileURL);
          }
          // let win = window.open(res.result.file_path);

          if (win.document.getElementsByTagName("iframe").length) {
            win = win.document.getElementsByTagName("iframe")[0].contentWindow;
          }
          win.onload = () => {
            this.openConfirmWindow(
              group.order_base_id_list,
              "order",
              group.ticket_id_list
            );
          };
          // eslint-disable-next-line no-warning-comments
          // TODO 更改该订单为 printed
        } catch (err) {
          console.log(err);
          Message(this.$t("ffm_print_status_failed"));
        }
      }
    },
    // 打印所有, 只能在云上
    async printAll() {
      await MessageBox.confirm(this.$t("ffm_confirm_to_multiprint"), "Alert", {
        type: "info"
      });
      let ids = this.printTableData.reduce((pre, next) => {
        return [...pre, ...next.order_base_id_list];
      }, []);
      this.printOrderOnCloud(ids);
      this.printCountDialogVisible = false;
    },
    // 轮询 1, 成功 , 2, 打印中,  3, 失败, 0, 取消 只要有一个是打印中, 就继续请求接口
    async polling(method, type) {
      let _this = this;
      try {
        let res = (await method(this.pollingQueue[`${type}s`])).result;
        // 显示进度
        this[`is_printing_${type}`] = true;
        // 更改显示队列
        this.printingItems[`${type}s`] = res || [];
        // 打印成功的元素
        this.successList = res.filter(v => v.status === SUCCESS_STATUS) || [];
        // unit or orders
        let finish = false;
        // 不包含打印中的状态, 则完成
        if (!res.length || !res.map(v => v.status).includes(PRINTING_STATUS)) {
          finish = true;
        }
        // 间隔两秒查询一次
        if (!finish) {
          setTimeout(() => {
            _this.polling(method, type);
          }, 1000);
          return;
        }
        this[`is_printing_${type}`] = false;
        // 打印完成而且打印弹窗关闭了, 才提示打印完成notify
        if (!this.isPrinting && !this.printingDialogVisible) {
          this.openSuccessNotify();
        }
        console.log(`print ${type} finish------------`);
      } catch (err) {
        console.log(err);
        Message.error(this.$t("ffm_get_print_status_fail"));
      }
    },
    // 关闭打印过程弹窗
    async processClose() {
      this.printingDialogVisible = false;
      if (this.isPrinting) {
        this.openPrintingNotify();
      } else {
        this.sInstance && this.sInstance.close && this.sInstance.close();
        this.successList = [];
        this.printingItems = {
          orders: [],
          units: []
        };
        // 轮询队列
        this.pollingQueue = {
          orders: [],
          units: []
        };
      }
    },
    // 先检查是否有打印任务
    async checkPrintingCode() {
      try {
        let res = (await getPrintingId()).result;
        // order或unit打印状态是用不同接口和参数
        if (res.order_base_id_list.length) {
          this.openPrintingNotify();
          this.pollingQueue.orders = res.order_base_id_list;
          this.polling(getOrderPrintStatus, "order");
        }
        if (res.unit_file_id_list.length) {
          this.openPrintingNotify();
          this.pollingQueue.units = res.unit_file_id_list;
          this.polling(getUnitPrintStatus, "unit");
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 打开打印中提示
    openPrintingNotify() {
      if (this.pInstance.closed === false) return;
      if (this.sInstance && this.sInstance.closed === false) {
        this.sInstance.close();
      }
      const h = this.$createElement;
      // 打印的提示框
      this.pInstance = Notification({
        customClass: "close-disable custom-notify",
        title: this.$t("ffm_is_printing"),
        iconClass: "el-icon-loading",
        offset: 35,
        message: h("p", null, [
          h(
            "i",
            {
              style: "color: teal;cursor:pointer;",
              on: {
                click: () => this.openPrintingDialog()
              }
            },
            this.$t("ffm_click_to_see")
          )
        ]),
        duration: 0
      });
    },
    // 打印成功窗口
    openSuccessNotify() {
      let _this = this;
      const h = this.$createElement;
      // 打印的提示框
      this.sInstance = Notification({
        offset: 35,
        type: "success",
        title: this.$t("ffm_print_finish"),
        onClose() {
          if (!_this.printingDialogVisible) {
            // 清空
            _this.successList = [];
            _this.printingItems = {
              orders: [],
              units: []
            };
            // 轮询队列
            _this.pollingQueue = {
              orders: [],
              units: []
            };
          }
        },
        message: h("p", null, [
          h(
            "i",
            {
              style: "color: teal;cursor:pointer;",
              on: {
                click: () => this.openPrintingDialog()
              }
            },
            this.$t("ffm_click_to_see")
          )
        ]),
        duration: 0
      });
    },
    // eslint-disable-next-line no-warning-comments
    // 取消打印任务 TODO ,取消打印状态
    async cancelPrint(item, type) {
      await MessageBox.confirm(this.$t("ffm_confirm_cancel_task"), "Alert", {
        type: "info"
      });
      try {
        // 区分打印order or unit
        if (type === "unit") {
          await cancelPrintUnit({
            unit_file_id: item.unit_file_id, // in query, unit_file_id,
            order_base_id: item.order_base_id // in query, order_base_id,
          });
        } else {
          await cancelPrintOrder([item.order_base_id]);
        }
      } catch (err) {
        Message.error(this.$t("ffm_cancel_fail"));
      }
    },
    // 打印order
    async printOrderOnCloud(ids) {
      try {
        let arr = [];
        ids.forEach(id => {
          // 原队列不包含 => 需要打印
          if (!this.pollingQueue.orders.includes(id)) {
            arr.push(id);
            return;
          }
          // 原队列包含但是是失败或者取消, 需要打印
          let status = this.printingItems.orders.find(
            v => v.order_base_id === id
          ).status;
          if ([CANCELED_STATUS, FAILURE_STATUS].includes(status)) {
            arr.push(id);
          }
        });
        // 只打印未在打印队列的order
        arr.length && (await printOrder(arr));
        // 轮询 - 新的轮询队列
        let newOrderQueue = [...new Set([...this.pollingQueue.orders, ...arr])];
        // 已经在轮询, 将id加入队列即可, 否则重新轮询
        this.pollingQueue.orders = newOrderQueue;
        !this.is_printing_order && this.polling(getOrderPrintStatus, "order");
        this.openPrintingDialog();
      } catch (err) {
        console.log(err);
        Message.error(this.$t("ffm_print_status_failed"));
      }
    },
    // 打印unit
    async printUnitOnCloud(data) {
      try {
        // 找到unit是否正在打印队列
        let item = this.printingItems.units.find(
          v => v.unit_file_id === data.unit_file_id
        );
        // 没在原队列, 或原队列包含但是失败或者取消, 需要打印
        if (!item || [CANCELED_STATUS, FAILURE_STATUS].includes(item.status)) {
          await printUnit(data);
          // 轮询 - 新的轮询队列 去重
          let newUnitQueue = [
            ...new Set([...this.pollingQueue.units, data.unit_file_id])
          ];
          // 已经在轮询, 将id加入队列即可, 否则重新轮询
          this.pollingQueue.units = newUnitQueue;
          !this.is_printing_unit && this.polling(getUnitPrintStatus, "unit");
        }
        // 否则直接打开弹窗
        this.openPrintingDialog();
      } catch (err) {
        console.log(err);
        Message.error(this.$t("ffm_print_status_failed"));
      }
    },
    openConfirmWindow(list, printType, ticketIds, parentId) {
      // 打开弹窗
      let text =
        'Please mark as "Printed" after successfully printed.\n' +
        printType +
        "s:" +
        (ticketIds.length ? ticketIds.join(",") : list.join(","));
      let status = {
        list: list,
        success: false,
        printType: printType,
        parentId: parentId,
        ticketIds: ticketIds
      };
      MessageBox.confirm(text, "Comfirm", {
        confirmButtonText: "Printed",
        cancelButtonText: "Unprinted",
        type: "info"
      })
        .then(() => {
          status.success = true;
          this.setStatus(status);
        })
        .catch(() => {
          this.setStatus(status);
        });
    },
    // 设置打印状态
    async setStatus(status) {
      let resultMessage = "ffm_print_status_success";
      let resultType = "success";
      try {
        // 未打印
        if (!status.success) throw new Error("fail");
        if (status.printType === "order") {
          await changeOrderPrintStatus(status.list);
        } else {
          await changeUnitPrintStatus({
            order_base_id: status.parentId,
            unit_file_id: status.list.join(",")
          });
        }
        this.search();
      } catch (err) {
        resultMessage = "ffm_print_cancel";
        resultType = "error";
      } finally {
        Notification({
          message: `${status.printType} ${
            status.ticketIds && status.ticketIds.length
              ? status.ticketIds
              : status.list
          } ${this.$t(resultMessage)}`,
          duration: 0,
          type: resultType
        });
      }
    }
  },
  mounted() {
    window.setPrintStatus = status => this.setStatus(status);
  },
  watch: {
    successList(next, old) {
      // 成功的时候刷新列表
      if (next.length > old.length) {
        this.search();
      }
    }
  }
};
